<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8 10C8.82843 10 9.5 9.32843 9.5 8.5C9.5 7.67157 8.82843 7 8 7C7.17157 7 6.5 7.67157 6.5 8.5C6.5 9.32843 7.17157 10 8 10ZM17.5 8.5C17.5 9.32843 16.8284 10 16 10C15.1716 10 14.5 9.32843 14.5 8.5C14.5 7.67157 15.1716 7 16 7C16.8284 7 17.5 7.67157 17.5 8.5ZM14 15.5359C13.3919 15.1848 12.7021 15 12 15C11.2979 15 10.6081 15.1848 10 15.5359C9.39192 15.887 8.88697 16.3919 8.5359 17C8.25976 17.4783 7.64817 17.6422 7.16987 17.366C6.69158 17.0899 6.52771 16.4783 6.80385 16C7.33046 15.0879 8.08789 14.3305 9 13.8038C9.91212 13.2772 10.9468 13 12 13C13.0532 13 14.0879 13.2772 15 13.8038C15.9121 14.3305 16.6695 15.0879 17.1962 16C17.4723 16.4783 17.3084 17.0899 16.8301 17.366C16.3518 17.6422 15.7402 17.4783 15.4641 17C15.113 16.3919 14.6081 15.887 14 15.5359Z"
      fill="#FF306E"
    />
  </svg>
</template>

<script>
export default {
  name: "NegativeIcon"
};
</script>
